import React from 'react'
import { Col } from "react-bootstrap";


const TechStack = ({Tech}) => {
    return (
        <Col xs={4} md={2}  className="tech-icons">
        {Tech}
      </Col>
    )
}

export default TechStack
